<template>
  <v-dialog v-model="dialog" :max-width="options.width" @keydown.esc="cancel()" persistent>
    <v-card light>
      <v-card-title :class="options.color ? options.color : 'black'" class="white--text">
        {{ title }}
      </v-card-title>
      <v-card-text class="pt-5" v-show="!!message">{{ message }}</v-card-text>
      <v-divider></v-divider>
      <v-card-actions :class="$vuetify.breakpoint.xsOnly && 'flex-column-reverse px-2'">
        <v-spacer></v-spacer>
        <v-btn
            data-cy="confirm-dialog-cancel"
            :block="$vuetify.breakpoint.xsOnly"
            :x-large="$vuetify.breakpoint.xsOnly"
            :class="$vuetify.breakpoint.xsOnly ? 'mt-2' : ''"
            @click.native="cancel()"
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
            data-cy="confirm-dialog-agree"
            :block="$vuetify.breakpoint.xsOnly"
            :x-large="$vuetify.breakpoint.xsOnly"
            :class="$vuetify.breakpoint.xsOnly ? 'ma-0' : ''"
            :color="options.buttonColor"
            v-if="options.agree"
            @click.native="agree()"
        >
          {{ options.agree }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Vuetify Confirm Dialog component
 *
 * Insert component where you want to use it:
 * <confirm ref="confirm"></confirm>
 *
 * Call it:
 * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {});
 *
 * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
 * <template>
 *   <v-app>
 *     ...
 *     <confirm ref="confirm"></confirm>
 *   </v-app>
 * </template>
 *
 * mounted() {
 *   this.$root.$confirm = this.$refs.confirm.open;
 * }
 */
export default {
  name: 'ConfirmDialog',

  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        agree: this.$t('yes'),
        cancel: this.$t('no'),
        width: 390,
        buttonColor: 'primary'
      },
    };
  },
  methods: {
    open(title, message, options) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>
